"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var RootReducer_1 = require("../../app/RootReducer");
var HelpExploreCard_1 = require("../../img/model-results/HelpExploreCard");
var TestIds_1 = require("../../util/TestIds");
var Utils_1 = require("../../util/Utils");
var Index_1 = require("../base/Index");
var NavigationContext_1 = require("../base/NavigationContext");
var ModelResultCumulativeChart_1 = require("./binomial/ModelResultCumulativeChart");
var ModelResultCoefficients_1 = require("./common/ModelResultCoefficients");
var ModelResultCrossValidation_1 = require("./common/ModelResultCrossValidation");
var GAIN_LEFT_CHART_WIDTH = 692;
var GAIN_LEFT_CHART_DIMENSION = 660;
var ModelResultExamineModel = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelType = _a.type, modelMetrics = _a.modelMetrics, modelCoefficients = _a.modelCoefficients;
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var setNavigationRef = function (node) {
        refs['MODEL_RESULT_EXAMINE_MODEL'] = node;
    };
    if (!modelMetrics || !modelType) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'examine-model' });
    }
    var renderBinomialModelContent = function () {
        var modelValidation = modelMetrics.validation;
        return (React.createElement(React.Fragment, null,
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.cumulativeGainChartTitle(), tooltip: Localize_1.Messages.cumulativeGainChartDescription(), width: GAIN_LEFT_CHART_WIDTH },
                    React.createElement(ModelResultCumulativeChart_1.default, { gainTable: modelValidation.gainTable, chartType: ModelResultCumulativeChart_1.ChartType.Gains, width: GAIN_LEFT_CHART_DIMENSION }))),
            React.createElement(Index_1.Card, null,
                React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.cumulativeCaptureChartTitle(), tooltip: Localize_1.Messages.cumulativeCaptureChartDescription(), width: GAIN_LEFT_CHART_WIDTH },
                    React.createElement(ModelResultCumulativeChart_1.default, { gainTable: modelValidation.gainTable, chartType: ModelResultCumulativeChart_1.ChartType.CumulativeCapture, width: GAIN_LEFT_CHART_DIMENSION })))));
    };
    /** TODO: no content yet */
    var renderRegressionModelContent = function () {
        return null;
    };
    var renderCrossValidation = function () {
        return (React.createElement(Index_1.Card, { styles: { width: '90%' } },
            React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.modelResultsCrossValidationTitle() },
                React.createElement(ModelResultCrossValidation_1.default, null))));
    };
    var renderCoefficients = function () {
        if (!modelCoefficients) {
            return null;
        }
        return (React.createElement(Index_1.Card, { styles: { width: '90%' } },
            React.createElement(Index_1.Card.Container, { header: Localize_1.Messages.modelResultsCoefficientsTitle() },
                React.createElement(ModelResultCoefficients_1.default, null))));
    };
    return (React.createElement("div", { ref: setNavigationRef, "data-tb-test-id": TestIds_1.MODEL_RESULT_EXAMINE_MODEL_TEST_ID },
        React.createElement(Index_1.Card.List, { icon: React.createElement(HelpExploreCard_1.HelpExploreCard, null), title: Localize_1.Messages.ModelResultExamineModelTitle(), description: Localize_1.Messages.ModelResultExamineModelSubtitle(), expand: true },
            renderCrossValidation(),
            renderCoefficients(),
            (0, Utils_1.isBinomialModel)(modelType) && renderBinomialModelContent(),
            (0, Utils_1.isRegressionModel)(modelType) && renderRegressionModelContent())));
};
exports.default = ModelResultExamineModel;
//# sourceMappingURL=ModelResultExamineModel.js.map